import React from 'react'
import { notification, message, Popover } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import NoData from '../com/NoData';
import Map from "../com/map";
import { formatSalaryRange, getSalaryDisplay, tagRedirect, checkLogin } from '../com//utils'
let path = Config.getBasePath();
let filePath = Config.getFilePath();
class JobInfo extends React.Component {
  constructor(props) {
    super(props)
    this.bodyRef = React.createRef();
    this.state = {
      job: {}
    }

  }
  async componentDidMount() {
    const { job } = this.props;
    this.fetchJobInfo(job?.id);
    // const search = window.location.search;
    // const params = new URLSearchParams(search);
    // const id = params.get('id');  
    // if (job) {
    //   this.ent_info(job?.enterprise_id);
    // } else if (id) {
    //   await this.setState({ job_id: id });
    //   this.fetchJobInfo();
    // }
    // this.jobList();
    if (this.bodyRef.current) {
      this.bodyRef.current.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {

    if (this.bodyRef.current) {
      this.bodyRef.current.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll = () => {
    if (this.bodyRef.current) {
      if (this.bodyRef.current.scrollTop > 0) {
        this.setState({ sticky: true })
      } else {
        this.setState({ sticky: false })
      }
    }
  }


  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.history?.location?.state?.data && prevState?.job) {
      if (JSON.stringify(prevProps?.history?.location?.state?.data) != JSON.stringify(prevState?.job)) {
        const { id, enterprise_id } = prevProps?.history?.location?.state?.data
        this.setState({ job_id: id, job: prevProps?.history?.location?.state?.data });
        if (enterprise_id) {
          this.ent_info(enterprise_id);
        }
      }
    }
  }

  ent_info = (id) => {
    WidgetAjax.ajax({
      url: path + "/enterprise/info",
      params: { id: id },
      callback: (res) => {
        if (res.status == 0) {
          this.setState({ ent_info: res.result });
        }
      },
    });
  }


  getWechartShare = () => {
    const { job } = this.state;
    WidgetAjax.ajax({
      url: path + '/weixin/wmp_qrcode',
      params: {
        application: "wmp|pzz",
        scene: `shareID=${job.id}`,
        page: `pages/laborHome/postDetail/postDetail`
      },
      callback: (res) => {
        if (res.status == 0) {
          this.setState({ wechartCode: res.result.result })
        }
      }
    });
  }



  job_box = (data) => {
    return <>
      {
        data && data.length > 0 ?
          data.map((item) => {
            let SAL = formatSalaryRange(item?.SALFROM, item?.SALTO);
            let SALFROM = SAL[0];
            let SALTO = SAL[1];
            return <div className={`job_item`} onClick={() => { this.job_info(item) }}>
              <div className='sf-page-tool-between'>
                <div className='job_name'>
                  <div className='job_JOBNAME'>{item.JOBNAME}</div>
                  {
                    item.IMPORTANCE === '2' ?
                      <img className='job_jz' src={require("../../img/pinzhunzhun/dataSource/jz.png")} /> : ""
                  }
                </div>
                <div className='job_SAL'>
                  {getSalaryDisplay(SALFROM, SALTO)}
                  {item.SALPAY == "11" ? "元/小时" : ""}
                  {item.SALPAY == "12" ? "元/天" : ""}
                  {item.SALPAY == "13" ? "元/周" : ""}
                </div>
              </div>
              <div className='require'>
                {item.REQWE_CN ? item.REQWE_CN : ""}
                {item.REQWE_CN ? <div className='line'>|</div> : ""}
                {!item.REQAGEFROM && !item.REQAGETO ? '不限年龄' : ""}
                {item.REQAGEFROM && !item.REQAGETO ? item.REQAGEFROM + '岁以上' : ""}
                {!item.REQAGEFROM && item.REQAGETO ? item.REQAGETO + '岁以内' : ""}
                {item.REQAGEFROM && item.REQAGETO ? item.REQAGEFROM + ' - ' + item.REQAGETO + '岁' : ""}
                {item.REQEDU_CN ? <div className='line'>|</div> : ""}
                {item.REQEDU_CN ? item.REQEDU_CN : ""}
              </div>
              <div className='job_tags'>
                {
                  item?.WELFARE && item?.WELFARE.length > 0 ? (
                    item.WELFARE.map((i) => {
                      return <div key={i} className='job_tag'>{i}</div>;
                    })
                  ) : null
                }
              </div>
              <div className='job_ent'>
                <div className='job_entName'>
                  <img className='job_logo' src={item?.ENTLOGO ? filePath + 'enterprise/M' + item.enterprise_id + '.png' : require('../../img/pinzhunzhun/dataSource/ent_logo.png')} />
                  {item?.ENTNAME}
                </div>
              </div>
            </div>
          })
          : <NoData width={"230px"} height={'230px'} />
      }
    </>

  }

  call = (job_id) => {
    WidgetAjax.ajax({
      url: path + "/job/call",
      params: { job_id: job_id },
      callback: (res) => {
        if (res.status == 0) {
          notification.open({
            message: '拨打电话',
            description: res.result?.TEL,
            placement: 'top',
            duration: null
          });
        }
      },
    });
  }

  application_add = (id) => {
    if (!checkLogin()) {
      message.warning('请先登录！');
      this.props.history.push({ pathname: "/login" });
      window.location.reload();
      return false;
    }

    const { resume } = this.props;
    if (resume && resume?.RIC && resume.RIC < 0.3 || resume.RIC == 0) return this.resumeRef.open()

    WidgetAjax.ajax({
      url: path + "/job/application_add",
      params: { job_id: id },
      callback: (res) => {
        if (res.status == 0) {
          // if (this.props && this.props.onChage) {
          //   this.props.onChage();
          // }
          this.fetchJobInfo(id);
          tagRedirect({ job_key: id }, 'sendNotice')
          notification.open({
            message: '报名成功',
            description: '报名成功',
            placement: 'top',
            duration: 2
          });
        }
      },
    });
  }

  job_info = (data) => {
    this.props.history.push({ pathname: "/home/jobdetails", state: { data } })
  }

  entInfo = (data) => {
    this.props.history.push({ pathname: "/home/enterprise/detail", state: { data } })
  }

  jump = () => {
    this.props.history.push({ pathname: "/home/resume" })
  }

  favor = (data) => {
    if (!checkLogin()) {
      message.warning('请先登录！');
      this.props.history.push({ pathname: "/login" });
      window.location.reload();
      return false;
    }
    let params = {
      job_id: data?.id,
    }
    const onFavor = (res) => {
      if (res.status == 0) {
        message.success("成功!");
        this.fetchJobInfo(data?.id);
        // if (this.props && this.props.onChage) {
        //   this.props.onChage(data);
        // }
      } else {
        message.error("失败");
      }
    }
    let url = data?.favor ? '/job/unfavor' : '/job/favor';
    WidgetAjax.ajax({ url: path + url, params, callback: onFavor });

  }

  // 用于获取职位信息的方法
  fetchJobInfo = (id) => {

    let params = { id }; // 假设接口需要的参数是 id
    const onJobInfo = (res) => {
      if (res.status === 0) {
        this.setState({
          job: res.result,
          loading: false
        });
        this.getWechartShare();
      } else {
        console.error('获取职位信息失败:', res.message);
        this.setState({ loading: false });
      }
    };
    WidgetAjax.ajax({ url: path + '/job/info', params, callback: onJobInfo });
  };




  render() {
    const { job, wechartCode, sticky } = this.state;
    const { resume } = this.props;
    return <div component-data="JobInfo">
      <div className='job_info_box' >
        <div className={sticky ? 'job_info_head has-shadow' : 'job_info_head'}>
          <div className='job-header-info'>
            <div className='job-detail-info'>
              <span className='job-name'>{job?.JOBNAME}</span>
              <span className='job-salary'>
                {getSalaryDisplay(job?.SALFROM, job?.SALTO)}
                {job?.SALPAY == "11" ? "元/小时" : ""}
                {job?.SALPAY == "12" ? "元/天" : ""}
                {job?.SALPAY == "13" ? "元/周" : ""}
              </span>
            </div>
            <ul className='tag-list'>
              <li>
                <img src={require("../../img/pinzhunzhun/dataSource/icon-ADDRESS.png")} />
                {job?.DISTRICT_CN}
              </li>
              <li >
                <img src={require("../../img/pinzhunzhun/dataSource/icon-exp.png")} />
                {job?.REQWE_CN ? job.REQWE_CN : ""}
              </li>
              <li >
                <img src={require("../../img/pinzhunzhun/dataSource/icon-edu.png")} />
                {job?.REQEDU_CN ? job.REQEDU_CN : ""}
              </li>
            </ul>
          </div>
          <div className='job-detail-op'>
            {
              job?.favor ?
                <a onClick={() => { this.favor(job) }} className='op-btn op-btn-likes'>取消收藏</a>
                :
                <a onClick={() => { this.favor(job) }} className='op-btn op-btn-like'>收藏</a>
            }
            {
              job?.application ?
                <a className='op-btn op-btn-chat' >已投递</a>
                :
                <a className='op-btn op-btn-chat' onClick={() => { this.application_add(job?.id) }}>立即投递</a>
            }


          </div>
        </div>

        <div className='job_info_body' ref={this.bodyRef} >
          {
            <div className='sf-page-tool-between'>
              <h3 className='job_info_title'>职位描述 </h3>
              <Popover
                placement="bottom"
                arrow={false}

                content={
                  <div className='wechat_share_box'>
                    <img src={`data:image/png;base64,${wechartCode}`} />
                    <div className='share_tips'>打开微信扫一扫</div>
                  </div>}>
                <a className='link-wechat-share'>微信扫码分享</a>
              </Popover>
            </div>
          }

          {
            job?.WELFARE && job?.WELFARE.length ?

              <ul className='job-label-list'>
                {job?.WELFARE.map((item) => {
                  return <li>{item}</li>
                })}
              </ul> : null
          }
          <div dangerouslySetInnerHTML={{ __html: job?.DETAIL }}></div>

          <div className='job-address'>
            <span className='job-address-title'>工作地址</span>
            <p className='job-address-desc'>{job?.ADDRESS} </p>
            {
              job?.LOCATION && job?.LOCATION.DISTRICT ? <div className='job-map_info'>
                <Map lat={job.LOCATION.DISTRICT.LAT} lng={job.LOCATION.DISTRICT.LNG} zoom={10} />
              </div> : null
            }

          </div>
          <a className='more-job-btn' onClick={() => { tagRedirect({ job_key: job?.id }, 'JobDetails') }} >查看更多</a>
        </div>
      </div>

      <WidgetModal onRef={ref => this.resumeRef = ref} onOk={() => this.jump()} options={{ title: '温馨提示', width: 500, isCancel: false, okText: '前往完善简历' }}>
        <div style={{ margin: '16px 0' }}>
          您当前简历完整度为{resume?.RIC * 100 || 0}%，请您进一步完善简历后，再行投递！
        </div>
      </WidgetModal>
    </div>

  }
}

export default JobInfo;